import { Badge } from '../catalyst/badge'
import type { AdminUser } from '../lib/types'
import { ListPage } from './list-page'

/** Staff-only `GET /admin/users` (server/src/apps/admin). */
export function UsersPage() {
  return (
    <ListPage<AdminUser>
      title="Users"
      description="Every account across all organizations."
      path="/admin/users"
      noun="users"
      columns={[
        { header: 'Name', primary: true, cell: (u) => u.name },
        { header: 'Email', cell: (u) => u.email },
        { header: 'Role', cell: (u) => (u.isStaff ? <Badge color="blue">Staff</Badge> : '—') },
        { header: 'Created', cell: (u) => new Date(u.createdAt).toLocaleDateString() },
      ]}
    />
  )
}
